import { DatePicker, Input } from 'antd';
import dayjs from 'dayjs';

import { ReactComponent as DateIcon } from '@assets/icons/date-suffix.svg';
import { ReactComponent as MapIcon } from '@assets/icons/map.svg';

import { FormProps } from '../type';
import * as S from './styled';

const FormAttendUser = ({
  formData,
  setFormData,
}: // isEditable,
FormProps) => {
  const { attendanceTime, name, phone, email, organization } = formData;

  return (
    <S.Container>
      <S.Item>
        <p>소속</p>
        <Input
          placeholder='소속을 입력하세요'
          value={organization}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, organization: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>
          이름 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          placeholder='이름을 입력하세요'
          value={name}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, name: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>
          휴대폰번호 <span style={{ color: '#FF0000' }}>*</span>
        </p>
        <Input
          placeholder='휴대폰번호를 입력하세요'
          value={phone}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, phone: value });
          }}
        />
      </S.Item>
      <S.Item>
        <p>이메일</p>
        <Input
          placeholder='이메일을 입력하세요'
          value={email}
          onChange={({ target: { value } }) => {
            setFormData({ ...formData, email: value });
          }}
        />
      </S.Item>
      <S.Item style={{ margin: 0 }}>
        <p>출석일시</p>
        <DatePicker
          placeholder='출석일시를 선택하세요'
          format='YYYY.MM.DD HH:mm'
          showTime
          suffixIcon={<DateIcon />}
          value={attendanceTime ? dayjs(attendanceTime) : dayjs()}
          onChange={e => {
            if (e)
              setFormData({ ...formData, attendanceTime: dayjs(e).format('YYYY-MM-DD HH:mm') });
          }}
        />
      </S.Item>
    </S.Container>
  );
};

export default FormAttendUser;
